export default __webpack_public_path__ + "static/media/4DB20F81-396D-4606-AAD6-09EC5551C9E2_1_105_c.7f292ebd.jpg";